const AUTH_STORAGE_KEY = 'isAuthenticated';

export const getIsAuthenticatedFromStorage = (): boolean => {
    try {
        return localStorage.getItem(AUTH_STORAGE_KEY) === 'true';
    } catch (error) {
        return false;
    }
};

export const setIsAuthenticatedToStorage = (value: boolean): void => {
    try {
        localStorage.setItem(AUTH_STORAGE_KEY, String(value));
    } catch (error) {
        console.error('Ошибка сохранения статуса авторизации в localStorage:', error);
    }
};

export const removeIsAuthenticatedFromStorage = (): void => {
    try {
        localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch (error) {
        console.error('Ошибка удаления статуса авторизации из localStorage:', error);
    }
};
